import React, { Component } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import { DateUtil } from "../fxms/datas/DateUtil";
import noDataToDisplay from "highcharts/modules/no-data-to-display";

import "./../css/VUP_dash.css";

HighchartsMore(Highcharts);
noDataToDisplay(Highcharts); // 모듈 활성화
Highcharts.setOptions({
  global: {
    timezoneOffset: -9 * 60, // GMT
  },
});

Highcharts.setOptions({
  lang: {
    noData: "데이터가 존재하지 않습니다",
  },
  noData: {
    style: {
      fontSize: "16px",
      color: "#999999"
    }
  }
});

class High extends Component {
  render() {
    // const { data, engUnitVal } = this.props;
    const { data, engUnitValCons, engUnitValProd, isDetailView, engId, isKepcoEpwr, chartHeight } = this.props;
    const defaultChartHeight = Number(chartHeight) > 0 ? Number(chartHeight) : 180;

    //console.log("data value : " + JSON.stringify(data));

    function prodData(data, engId) {
      if (engId === 'EPWR') {
        // 전력(EPWR)일 때는 공급 데이터 없음
        return [];
      }
      let prodResult = [];
      for (let res of data) {
        if (res.prodInstVal !== undefined && res.psDate !== undefined) {
          prodResult.push([DateUtil.makeDate(res.psDate).getTime(), res.prodInstVal]);
        }
      }
      prodResult.sort((a, b) => a[0] - b[0]);
      return prodResult;
    }

    function consData(data) {
      let consResult = [];
      for (let res of data) {
        if(res.engId === "EPWR")
        {
           consResult.push([DateUtil.makeDate(res.psDate).getTime(), parseFloat(res.consAmt || 0)]);
        }else if (res.consInstVal !== undefined && res.psDate !== undefined) {
          
            consResult.push([DateUtil.makeDate(res.psDate).getTime(), parseFloat(res.consInstVal || 0)]);
          
          
        }
      }
      consResult.sort((a, b) => a[0] - b[0]);
      return consResult;
    }

    // 시리즈 조건 분기
    let series = [];
    if (engId === 'EPWR') {
      const label = isKepcoEpwr ? "전력량" : "수요";
      series = [
        {
          name: label,
          type: 'line',
          data: consData(data),
          lineWidth: 1,
          color: "#85D775",
          fillOpacity: 0.4,
          zIndex: 1,
          lineColor: "#85D775",
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 2,
          },
          connectNulls: true
        }
      ];
    } else {
      // 그 외는 "공급" + "수요"
      series = [
        {
          name: "공급",
          type: 'line',
          data: prodData(data, engId),
          lineWidth: 1,
          color: "#29A7A4",
          fillOpacity: 0.4,
          zIndex: 1,
          lineColor: "#29A7A4",
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 2,
          },
          connectNulls: true
        },
        {
          name: "수요",
          type: 'line',
          data: consData(data),
          lineWidth: 1,
          color: "#85D775",
          fillOpacity: 0.4,
          zIndex: 1,
          lineColor: "#85D775",
          marker: {
            enabled: true,
            symbol: 'circle',
            radius: 2,
          },
          connectNulls: true
        }
      ];
    }
    
    // x축 범위 설정 (KEPCO 데이터는 실데이터 구간으로)
    const today = new Date();
    const startOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
    const endOfDay = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();

    const options = {
      chart: {
        backgroundColor: "transparent",
        showNoData: 'true',
        events: {
          click: (e) => {
            if (this.props.onDetailView) {
              this.props.onDetailView(e);
            }
          },
          render: function () {
            if (this.wheelEventAdded) return;
            this.wheelEventAdded = true;
            this.container.addEventListener('wheel', (event) => {
              event.preventDefault();
              const chart = this;
              const xAxis = chart.xAxis[0];

              // 마우스 위치 → x축 값
              const rect = chart.container.getBoundingClientRect();
              const mouseX = event.clientX - rect.left;
              const xValue = xAxis.toValue(mouseX, true);

              const min = xAxis.min;
              const max = xAxis.max;
              const range = max - min;

              // 커서가 차지하는 비율
              const ratio = (xValue - min) / range;

              // 줌 인/아웃 비율
              const zoomFactor = event.deltaY < 0 ? 0.8 : 1.25;
              const newRange = range * zoomFactor;

              // 커서 위치 고정 계산
              let newMin = xValue - newRange * ratio;
              let newMax = xValue + newRange * (1 - ratio);

              // 최대 축소 상태라면 반드시 0시~24시로 복원
              if (newMin <= startOfDay && newMax >= endOfDay) {
                xAxis.setExtremes(startOfDay, endOfDay, true, false);
              } else {
                xAxis.setExtremes(newMin, newMax, true, false);
              }
            });
          }
        }
      },
      title: {
        text: null,
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        formatter: function () {
          let tooltip = '<span style="font-size: 10px">' + Highcharts.dateFormat('%Y년 %m월 %d일 %H시 %M분', this.x) + '</span><br/>';
          this.points.forEach(function (point) {
            let unit = point.series.name === "공급" ? engUnitValProd : engUnitValCons;
            tooltip += '<span style="color:' + point.series.color + '">●</span> ' + point.series.name + ': <b>' + Math.round(point.y).toLocaleString() + ' ' + unit + '</b><br/>';
          });
          return tooltip;
        }
      },
      xAxis: {
        type: "datetime",
        lineColor: '#555',
        min: startOfDay,
        max: endOfDay,
        tickInterval: 3 * 60 * 60 * 1000, // 3시간 단위
        labels: {
          style: {
            color: "rgba(255,255,255,0.8)",
          },
          formatter: function () {
            let date = new Date(this.value);
            let hour = date.getHours();
            let minute = date.getMinutes();
            if (minute === 0) return hour + "시";
            return '';
          },
        },
      },

      yAxis: {
        title: {
          text: null,
        },
        lineWidth: 1,
        lineColor: '#555',
        gridLineColor: '#555',
        labels: {
          formatter: function () {
            return Math.round(this.value).toLocaleString();
          }
        }
      },

      plotOptions: {
        series: {
          cursor: 'pointer', // 마우스 커서도 손모양으로
          point: {
            events: {
              click: (e) => {
                // 데이터 포인트 클릭 시
                if (this.props.onDetailView) {
                  this.props.onDetailView(e);
                }
              }
            }
          }
        }
      },

      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',     
        verticalAlign: 'bottom', 
        itemStyle: {
          color: '#fff',
        },
        symbolWidth: 0,
        useHTML: true,
        labelFormatter: function () {
          const isVisible = this.visible !== false; // 숨겨진 경우 false
          return `<div style="display: flex;align-items: center;gap: 8px;opacity:${isVisible ? 1 : 0.5};">
            <span style="width:14px;height:14px;background-color:${this.color};border-radius: 50%;"></span>
            <span style="font-size: 14px;color:${isVisible ? 'white' : '#888'}">${this.name}</span>
          </div>`;
        },
      },

      series: series,
      
      lang: {
        noData: "데이터가 존재하지 않습니다", // 데이터가 없을 때 보여줄 메시지
      },
    };

    return (
      // <div>
        <HighchartsReact
          containerProps={{ style: {
            height: isDetailView ? "450px" : `${defaultChartHeight}px`,
            width: "100%"} 
          }}
          highcharts={Highcharts}
          options={options}
        />
      // </div>
    );
  }
}

export const EngLineChart = (props) => {
  // const {data, fields, engUnitVal} = props;
  const { data, fields, engUnitValCons, engUnitValProd, isDetailView, onDetailView, engId, isKepcoEpwr, chartHeight } = props;

  return (
    <>
      <High
        data={data}
        // engUnitVal={engUnitVal} 
        engUnitValCons={engUnitValCons}
        engUnitValProd={engUnitValProd}
        isDetailView={isDetailView}
        onDetailView={onDetailView}
        engId={engId}
        isKepcoEpwr={isKepcoEpwr}
        chartHeight={chartHeight}
      />
    </>
  );
};
